module.exports = __webpack_public_path__ + "img/ldx_img@2x.a28480a7.png";